import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToastsComponent } from './toasts/toasts.component';
import { NgbToastModule } from '@ng-bootstrap/ng-bootstrap';

@NgModule({
  declarations: [ToastsComponent],
  imports: [CommonModule, NgbToastModule],
  exports: [ToastsComponent],
})
export class ToastsModule {}
